// source: pbtypes/gen/structure/structure_object.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_trans_pb = require('../../../pbtypes/gen/body/trans_pb.js');
goog.object.extend(proto, pbtypes_gen_body_trans_pb);
var pbtypes_gen_structure_frame_pb = require('../../../pbtypes/gen/structure/frame_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_frame_pb);
var pbtypes_gen_structure_geometry_pb = require('../../../pbtypes/gen/structure/geometry_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_geometry_pb);
goog.exportSymbol('proto.structure.StructureObject', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.structure.StructureObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.structure.StructureObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.structure.StructureObject.displayName = 'proto.structure.StructureObject';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.structure.StructureObject.prototype.toObject = function(opt_includeInstance) {
  return proto.structure.StructureObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.structure.StructureObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.StructureObject.toObject = function(includeInstance, msg) {
  var f, obj = {
frame: (f = msg.getFrame()) && pbtypes_gen_structure_frame_pb.Frame.toObject(includeInstance, f),
frameTObject: (f = msg.getFrameTObject()) && pbtypes_gen_body_trans_pb.TransPb.toObject(includeInstance, f),
geometry: (f = msg.getGeometry()) && pbtypes_gen_structure_geometry_pb.Geometry.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.structure.StructureObject}
 */
proto.structure.StructureObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.structure.StructureObject;
  return proto.structure.StructureObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.structure.StructureObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.structure.StructureObject}
 */
proto.structure.StructureObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_structure_frame_pb.Frame;
      reader.readMessage(value,pbtypes_gen_structure_frame_pb.Frame.deserializeBinaryFromReader);
      msg.setFrame(value);
      break;
    case 2:
      var value = new pbtypes_gen_body_trans_pb.TransPb;
      reader.readMessage(value,pbtypes_gen_body_trans_pb.TransPb.deserializeBinaryFromReader);
      msg.setFrameTObject(value);
      break;
    case 3:
      var value = new pbtypes_gen_structure_geometry_pb.Geometry;
      reader.readMessage(value,pbtypes_gen_structure_geometry_pb.Geometry.deserializeBinaryFromReader);
      msg.setGeometry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.structure.StructureObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.structure.StructureObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.structure.StructureObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.StructureObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrame();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_structure_frame_pb.Frame.serializeBinaryToWriter
    );
  }
  f = message.getFrameTObject();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_body_trans_pb.TransPb.serializeBinaryToWriter
    );
  }
  f = message.getGeometry();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_structure_geometry_pb.Geometry.serializeBinaryToWriter
    );
  }
};


/**
 * optional Frame frame = 1;
 * @return {?proto.structure.Frame}
 */
proto.structure.StructureObject.prototype.getFrame = function() {
  return /** @type{?proto.structure.Frame} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_structure_frame_pb.Frame, 1));
};


/**
 * @param {?proto.structure.Frame|undefined} value
 * @return {!proto.structure.StructureObject} returns this
*/
proto.structure.StructureObject.prototype.setFrame = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.StructureObject} returns this
 */
proto.structure.StructureObject.prototype.clearFrame = function() {
  return this.setFrame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.StructureObject.prototype.hasFrame = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional body.TransPb frame_t_object = 2;
 * @return {?proto.body.TransPb}
 */
proto.structure.StructureObject.prototype.getFrameTObject = function() {
  return /** @type{?proto.body.TransPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_trans_pb.TransPb, 2));
};


/**
 * @param {?proto.body.TransPb|undefined} value
 * @return {!proto.structure.StructureObject} returns this
*/
proto.structure.StructureObject.prototype.setFrameTObject = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.StructureObject} returns this
 */
proto.structure.StructureObject.prototype.clearFrameTObject = function() {
  return this.setFrameTObject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.StructureObject.prototype.hasFrameTObject = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Geometry geometry = 3;
 * @return {?proto.structure.Geometry}
 */
proto.structure.StructureObject.prototype.getGeometry = function() {
  return /** @type{?proto.structure.Geometry} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_structure_geometry_pb.Geometry, 3));
};


/**
 * @param {?proto.structure.Geometry|undefined} value
 * @return {!proto.structure.StructureObject} returns this
*/
proto.structure.StructureObject.prototype.setGeometry = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.StructureObject} returns this
 */
proto.structure.StructureObject.prototype.clearGeometry = function() {
  return this.setGeometry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.StructureObject.prototype.hasGeometry = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.structure);
